import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

export const INVENTORY_ITEMS_STATUS = {
  NOT_FOUND: 'Não encontrado',
  UNEXPECTED: 'Inesperado',
  FOUND: 'Encontrado'
}

class InventoryItemsStatusSelector extends BaseSelectorReadonlyToInput {

  inventoryStatusData = Object.keys(INVENTORY_ITEMS_STATUS).map(value => ({ value, label: INVENTORY_ITEMS_STATUS[value] }))

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: props.title || 'Status dos itens do inventário',
      label: 'label',
      value: 'value',
      placeholder: props.placeholder,
      style: props.style,
      items: this.inventoryStatusData
    };
  }
}

export default InventoryItemsStatusSelector



// WEBPACK FOOTER //
// ./src/Inventory/components/InventoryItemsStatusSelector.js